import React from 'react';

const FurnitureIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <mask id="mask0_2050_18524" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2050_18524)">
        <path d="M4.5 20.75V5.30775C4.5 4.81058 4.677 4.385 5.031 4.031C5.385 3.677 5.81058 3.5 6.30775 3.5H17.6923C18.1894 3.5 18.615 3.677 18.969 4.031C19.323 4.385 19.5 4.81058 19.5 5.30775V20.75H18V18.6345H6V20.75H4.5ZM6 11.3655H11.25V5H6.30775C6.21792 5 6.14417 5.02883 6.0865 5.0865C6.02883 5.14417 6 5.21792 6 5.30775V11.3655ZM12.75 7.43275H18V5.30775C18 5.21792 17.9712 5.14417 17.9135 5.0865C17.8558 5.02883 17.7821 5 17.6923 5H12.75V7.43275ZM12.75 11.3655H18V8.93275H12.75V11.3655ZM10.25 15.75H13.75V14.25H10.25V15.75ZM6 12.8652V17.1348H18V12.8652H6Z" fill="#6D7885" />
      </g>
    </svg>
  );
};

export default FurnitureIcon;